// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34Jzs","questions":"styles_questions__2VrXC","footer":"styles_footer__381Ez"};